module.exports = __webpack_public_path__ + "static/media/ExternalLink.a8d1a808.svg";